const DataSubMenu = ({subNavOptions, setActiveTab, activeTab }) => {
    return (
        <ul className="data-submenu tif-mb-0">
            {subNavOptions.map((option) => (
                <li key={option?.id || option} className={activeTab === option || activeTab === option?.id ? 'active' : ''} onClick={() => setActiveTab(option?.id || option)}>
                    {option?.label || option}
                </li>
            ))}
        </ul>
    );
};

export default DataSubMenu;